/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { AccessDenied } from '@leegality/leegality-react-component-library';
import useTranslation from '../../../utils/translation-utils';

const AccessDeniedWrapper = ({ title, description, buttonProps }) => {
  const navigate = useNavigate();
  const [getTranslation] = useTranslation();

  const updatedButtonProps = useMemo(() => ({
    label: getTranslation('GO_BACK'),
    onClick: () => navigate(-1),
    ...buttonProps,
  }), []);

  return (
    <AccessDenied
      title={getTranslation(title)}
      description={description ? getTranslation(description) : getTranslation('MSG_ACCESS_DENIED')}
      {...updatedButtonProps}
    />
  );
};

AccessDeniedWrapper.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  buttonProps: PropTypes.shape({}),
};

AccessDeniedWrapper.defaultProps = {
  title: 'ACCESS_DENIED',
  description: 'MSG_ACCESS_DENIED',
  buttonProps: {},
};

export default AccessDeniedWrapper;
